var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffbd47;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.26,6.89c-1.86,0-3.37,1.51-3.37,3.37s1.51,3.37,3.37,3.37,3.37-1.51,3.37-3.37-1.51-3.37-3.37-3.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.26,5.9c-.36,0-.66-.29-.66-.66v-1.05c0-.36,.29-.66,.66-.66s.66,.29,.66,.66v1.05c0,.36-.3,.66-.66,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.26,14.63c-.36,0-.66,.29-.66,.66v1.05c0,.36,.29,.66,.66,.66s.66-.29,.66-.66v-1.05c0-.36-.3-.66-.66-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.35,7.18c-.26-.26-.26-.67,0-.93l.74-.74c.26-.26,.67-.26,.93,0,.26,.26,.26,.67,0,.93l-.74,.74c-.26,.26-.67,.26-.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.18,13.35c-.26-.26-.67-.26-.93,0l-.74,.74c-.26,.26-.26,.67,0,.93s.67,.26,.93,0l.74-.75c.26-.26,.26-.67,0-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.63,10.26c0-.36,.29-.66,.66-.66h1.05c.36,0,.66,.29,.66,.66s-.29,.66-.66,.66h-1.05c-.36,0-.66-.29-.66-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.9,10.26c0-.36-.29-.66-.66-.66h-1.05c-.36,0-.66,.29-.66,.66s.29,.66,.66,.66h1.05c.36,0,.66-.29,.66-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.35,13.35c.26-.26,.67-.26,.93,0l.74,.74c.26,.26,.26,.67,0,.93s-.67,.26-.93,0l-.74-.74c-.26-.26-.26-.67,0-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.18,7.18c.26-.26,.26-.67,0-.93l-.74-.74c-.26-.26-.67-.26-.93,0-.26,.26-.26,.67,0,.93l.74,.74c.26,.26,.67,.26,.93,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.3bb2553f989d28239c3003cace103739.svg";
export { ForwardRef as ReactComponent };